import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { UserContext } from '../context/authContext';
import React, { useContext, useEffect, useState, useRef } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import { ICompanyAccount } from '../lib/models/interfaces';
import { KoruLoading } from './Components/shared/KoruLoading';
import { DocumentContext } from '../context/documentContext';
import { ErrorBoundaryCustom } from './Components/errorScreen/ErrorBoundaryCustom';
import { ServerErrorScreen } from './Components/shared/ServerErrorPage';

export const ProtectedRoute = (): any => {
  const {
    token,
    setToken,
    isExpired,
    companyAccount,
    authHydrated,
    subscription,
    rehydrateAuth,
    authHydratedError
  } = useContext(UserContext);
  const { getAllDocumentsLoading, initialLoad } = useContext(DocumentContext);
  const location = useLocation();
  const cookieToken = Cookies.get('token');

  // On mount, hydrate context token from cookie if present and not expired
  useEffect(() => {
    if (cookieToken && !isExpired(cookieToken)) {
      setToken(cookieToken);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const effectiveToken = cookieToken || token || '';
  const authed =
    Boolean(effectiveToken) && !isExpired(effectiveToken as string);

  // Stripe rehydration logic
  const rehydrateRanRef = useRef(false);
  const [refreshingAfterStripe, setRefreshingAfterStripe] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const hasStripeReturn =
      params.has('session_id') ||
      // params.has('redirect_status') ||
      params.get('nosub') === 'true';
    // params.get('stripe') === '1';

    if (hasStripeReturn && !rehydrateRanRef.current) {
      rehydrateRanRef.current = true;
      setRefreshingAfterStripe(true);
      rehydrateAuth().finally(() => setRefreshingAfterStripe(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key]);

  if (!authed) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: { pathname: location.pathname, search: location.search }
        }}
      />
    );
  }

  if (!authHydrated || refreshingAfterStripe) {
    return <KoruLoading centerText="Gathering Account Info" />;
  }
  if (authHydratedError) {
    return (
      <ErrorBoundaryCustom>
        <ServerErrorScreen />
      </ErrorBoundaryCustom>
    );
  }

  if (getAllDocumentsLoading && initialLoad) {
    return <KoruLoading centerText="Getting Documents" />;
  }

  // --- Subscription & route guards (refactored) ---
  const hasStripeCustomerId = Boolean(companyAccount?.stripeCustomerId);
  const subs = companyAccount?.subscriptions ?? [];
  const lastSub = subs.length > 0 ? subs.at(-1)! : undefined;
  console.log('last sub expire date', lastSub?.current_period_end! * 1000);
  console.log('new date value', Date.now());

  const lastSubValid = !!(
    lastSub && lastSub.current_period_end * 1000 > Date.now()
  );
  console.log('last sub valid', lastSubValid);
  console.log('lastSUb', lastSub);
  const hasValidSubscription =
    lastSubValid &&
    (lastSub?.status === 'active' || lastSub?.status === 'trialing');
 

  console.log('has valid subscription', hasValidSubscription);
  const isOnNoSubAccountNew =
    location.pathname === '/account-new' &&
    new URLSearchParams(location.search).get('nosub') === 'true';

  const isOnConfirmationWithSession =
    location.pathname === '/confirmation' &&
    new URLSearchParams(location.search).has('session_id');

  // Case A: Visiting /confirmation?session_id=... from Stripe return URL → always allow
  if (isOnConfirmationWithSession) {
    return <Outlet />;
  }

  // If the user already has a valid subscription, do not allow visiting the new-account page(s)
  if (hasValidSubscription && location.pathname === '/account-new') {
    return <Navigate to="/app/landing" replace />;
  }

  // Case B: NO subscription AND NO stripeCustomerId → /account-now
  if (!hasValidSubscription && !hasStripeCustomerId) {
    if (location.pathname !== '/account-new') {
      return <Navigate to="/account-new" replace />;
    }
    return <Outlet />;
  }

  // Case C: NO subscription AND HAS stripeCustomerId → /account-new?nosub=true
  if (!hasValidSubscription && hasStripeCustomerId) {
    // if (!isOnNoSubAccountNew && !isOnConfirmationWithSession && expiredSub) {
    //   return <Navigate to="/account-new?nosub=true&expiredSub=true" replace />;
    // }
    if (!isOnNoSubAccountNew && !isOnConfirmationWithSession) {
      return <Navigate to="/account-new?nosub=true" replace />;
    }
    return <Outlet />;
  }

  // Default: allow access
  return <Outlet />;
};
